import type { AuthLayoutProps } from '@/types';

export function AuthLayout({ children }: AuthLayoutProps) {
  return <div className="min-h-screen">{children}</div>;
}
